export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-prohibited-f7e6cbc27b268eeeef20053a53fb6953.svg";